import { render, staticRenderFns } from "./radsys.vue?vue&type=template&id=c3d894d8&scoped=true"
import script from "./radsys.vue?vue&type=script&lang=js"
export * from "./radsys.vue?vue&type=script&lang=js"
import style0 from "./radsys.vue?vue&type=style&index=0&id=c3d894d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d894d8",
  null
  
)

export default component.exports